"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendBusinessMetric = exports.sendMetricBatch = exports.sendMetric = exports.debounceWithQueue = void 0;
var tslib_1 = require("tslib");
var logging_1 = require("../logging");
var axios_1 = tslib_1.__importDefault(require("axios"));
var lodash_1 = tslib_1.__importDefault(require("lodash"));
var _1 = require(".");
var debounceWithQueue = function (fn, wait, _a) {
    if (_a === void 0) { _a = {}; }
    var _b = _a.maxSize, maxSize = _b === void 0 ? Infinity : _b, _c = _a.context, context = _c === void 0 ? null : _c, debounceOptions = tslib_1.__rest(_a, ["maxSize", "context"]);
    var args = [];
    var runFn = function () {
        fn(tslib_1.__spreadArray([], tslib_1.__read(args), false));
        args.length = 0;
    };
    var debounced = lodash_1.default.debounce(runFn, wait, debounceOptions);
    var cancel = function () {
        debounced.cancel();
        args.length = 0;
    };
    var queuedDebounce = function () {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        args.push(params);
        if (args.length >= maxSize)
            debounced.flush();
        else
            debounced();
    };
    queuedDebounce.cancel = cancel;
    queuedDebounce.flush = debounced.flush;
    return queuedDebounce;
};
exports.debounceWithQueue = debounceWithQueue;
/**
 * @type {(name:string, sourceApp?:string, dimensions?:any, value?:Number) => void}
 */
exports.sendMetric = (0, exports.debounceWithQueue)(function (args) { return module.exports.sendMetricBatch(args); }, 100);
/**
 * @param {[name: string, sourceApp?: string, dimensions?:any, value?: number,][]} metrics Array of metrics
 * @returns undefined if no metrics were sent
 */
function sendMetricBatch(metrics) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var payload;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    payload = [];
                    metrics.forEach(function (metric) {
                        var _a = tslib_1.__read(metric, 4), name = _a[0], _b = _a[1], sourceApp = _b === void 0 ? window.location.hostname : _b, _c = _a[2], dimensions = _c === void 0 ? {} : _c, _d = _a[3], value = _d === void 0 ? 1 : _d;
                        if (process.env.NODE_ENV === 'development') {
                            // eslint-disable-next-line no-console
                            console.log('METRIC:' + name, sourceApp, dimensions);
                            return;
                        }
                        if (!metric || !name)
                            return;
                        if (typeof name !== 'string')
                            return;
                        payload.push({
                            name: name,
                            value: value,
                            source: {
                                app: sourceApp,
                                stage: process.env.REACT_APP_DEPLOY_ENV,
                                env: process.env.REACT_APP_DEPLOY_ENV,
                            },
                            dimensions: dimensions,
                        });
                    });
                    if (!payload.length)
                        return [2 /*return*/];
                    return [4 /*yield*/, axios_1.default.post("/api/metrics", payload).catch(function (err) {
                            console.error(err);
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.sendMetricBatch = sendMetricBatch;
var processBusinessMetric = function () {
    var batchSize = 10;
    var buffer = [];
    var timer;
    /**@type {(event: string, dimensions: {[key: string]: string | number | Date | Array<string | number | Date>})} */
    return function (event, dimensions) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            buffer.push({ event: event, dimensions: dimensions });
            if (timer)
                clearTimeout(timer);
            timer = setTimeout(function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
                var batch, err_1;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!buffer.length) return [3 /*break*/, 5];
                            batch = buffer.splice(0, batchSize);
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, axios_1.default.post(process.env.REACT_APP_BUSINESS_METRICS_API_URL, JSON.stringify(batch), {
                                    headers: {
                                        Authorization: _1.tokenStorage.get(),
                                    },
                                })];
                        case 2:
                            _a.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            (0, logging_1.logError)(err_1, 'sendBusinessMetric', 'unable to send business metric to queue');
                            return [3 /*break*/, 4];
                        case 4: return [3 /*break*/, 0];
                        case 5:
                            clearTimeout(timer);
                            timer = null;
                            return [2 /*return*/];
                    }
                });
            }); }, 1000);
            return [2 /*return*/];
        });
    }); };
};
/**
 * Log business metrics to MySql, to be surfaced in Metabase
 * @example sendBusinessMetric('event.name', {dimension1: "value", dimension2: 123, dimension3: [1, 2]});
 */
exports.sendBusinessMetric = processBusinessMetric();
